import Vue from 'vue'
import App from './App.vue'
import axios from "axios"
import smcrypto from 'sm-crypto'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'

// 引入echarts  
import * as echarts from 'echarts'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$smCrypto=smcrypto
Vue.prototype.$key_all="02a9fa092d95434eea7998ee6fa25a0abeda98496575685063608815fd9da1eb5c"//公钥
Vue.prototype.$key_private="45057a186fd0f310ebfa86a559f56080e4d4631d766b09c07b9f8a5a52851257" //私钥
Vue.prototype.$url=`https://api.heiban.icu/`
 Vue.prototype.$urls=`https://api.heiban.icu/`
// Vue.prototype.$urls=`http://localhost:3000/`
Vue.prototype.$echarts = echarts

// 设置axios超时时间为无限制
axios.defaults.timeout = 0;
Vue.prototype.$axios = axios;
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
